<template>
  <div style="padding-right: 27px;">
    <div class="row">
      <div class="col-md-12">
        <div style="text-align: center">
          <h5>{{ data.name }}</h5>
        </div>
        <ckeditor :editor="editor" v-model="note" :config="ckEditorConfig"></ckeditor>
        <button type="button" @click="saveNote" class="btn btn-fill btn-info pull-right">
          Save
        </button>
        <button type="button" @click="close" class="btn btn-fill btn-info pull-right">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import ckEditorConfig from 'src/utilities/ckeditor'
import {notifyError, notifySuccess} from '@/utilities/utils'
import {ptracPatchEntity} from '@/utilities/ptracApi'

export default {
  props: ['data'],
  components: {
    ckeditor: CKEditor.component
  },
  data () {
    return {
      editor: ClassicEditor,
      ckEditorConfig,
      note: ''
    }
  },
  methods: {
    async saveNote() {
      const response = await ptracPatchEntity('tasks/' + this.data.id, {notes: this.note})

      if (response.status === 200) {
        notifySuccess(this, 'Task note saved successfully')
        const payload = {taskId: this.data.id, noteToAppend: this.note}
        this.$eventHub.$emit('appendNote', payload)
      } else {
        notifyError(this, 'Failed to save task note')
      }

      this.close()
    },
    close() {
      this.$emit('close')
    }
  },
  created() {
    if (this.data && this.data.notes) {
      this.note = this.data.notes
    }
  }
}
</script>

<style scoped>

</style>
